import {
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
} from "react-router";

import type { LinksFunction } from "react-router";
import tailwindStyles from "~/tailwind.css?url";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { RecoilRoot } from "recoil";
import { useEffect } from "react";

// Keep the global styles in React's document tree. Vite's injected <style>
// can be lost when React 18 remounts the document after a hydration error.
export const links: LinksFunction = () => [
  { rel: "stylesheet", href: tailwindStyles },
];

export default function App() {
  useEffect(() => {
    // Clarity inserts scripts into <head>. Wait until hydration has finished so
    // those nodes cannot displace the server-rendered head during hydration.
    if (document.querySelector("script[data-wishlist-clarity]")) return;
    const script = document.createElement("script");
    script.dataset.wishlistClarity = "true";
    script.textContent = `
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "mrpn28v6kz");
    `;
    document.head.appendChild(script);
  }, []);

  return (
    <html>
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <link rel="preconnect" href="https://cdn.shopify.com/" />
        <link
          rel="stylesheet"
          href="https://cdn.shopify.com/static/fonts/inter/v4/styles.css"
        />
        <Meta />
        <Links />
      </head>
      <body style={{ height: "100%" }}>
        <RecoilRoot>
          <I18nextProvider i18n={i18n}>
            <Outlet />
          </I18nextProvider>
        </RecoilRoot>
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}
